import React from 'react';

import * as S from './style';

export const Description = ({ color, children, style }) => (
  <S.Description color={color} style={style}>
    {children}
  </S.Description>
);
